<template>
  <div v-html="content"></div>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    content () {
      return ''
    }
  }
}
</script>